import DisplayedFileData from "@src/components/deprecated/FilePopup/DisplayedFileData";
import { useDownloadFile } from "@src/utils/hooks/useDownloadFile";
import { AriaButton } from "../Buttons/AriaButton/AriaButton";
import { Download } from "@src/assets/images/icons/untitled_ui_icons";
import TypographyText from "../TypographyText/TypographyText";
import { t } from "i18next";

interface FilePreviewProps {
  file: DisplayedFileData;
}

export const PreviewNotAvailable = ({ file }: FilePreviewProps) => {
  const { isDownloading, download } = useDownloadFile(file, file.propertyID);

  return (
    <div style={{ margin: "auto", gap: "10px", display: "flex", flexDirection: "column", alignItems: "center" }}>
      <TypographyText as="p">{t("main.previewNotAvailable")}</TypographyText>
      <AriaButton isLoading={isDownloading} onPress={download}>
        <Download />
        {t("main.download")}
      </AriaButton>
    </div>
  );
};
